import { 
  Settings, RefreshCw, Upload, 
  GraduationCap, Shield, HeartHandshake 
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const servicesIcons: LucideIcon[] = [
  Settings,
  Upload,
  RefreshCw,
  GraduationCap,
  Shield,
  HeartHandshake
];